import { render } from "./PatientVitalsView.vue?vue&type=template&id=24b3e568"
import script from "./PatientVitalsView.vue?vue&type=script&lang=js"
export * from "./PatientVitalsView.vue?vue&type=script&lang=js"

import "./PatientVitalsView.vue?vue&type=style&index=0&id=24b3e568&lang=scss"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__